import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// import Tooltip from "@material-ui/core/Tooltip";
// @material-ui/icons
// import FormatAlignLeft from "@material-ui/icons/FormatAlignLeft";
// core components

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
// import Button from "components/CustomButtons/Button.jsx";

import cardProject6 from "assets/img/Kinos/Brokers/card-project6.jpg";

import RegisterForm from "./RegisterForm.jsx";

import sectionPillsStyle from "assets/jss/material-kit-pro-react/views/blogPostsSections/sectionPillsStyle.jsx";
// import descriptionStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/descriptionStyle.jsx";

function SectionPills({ ...props }) {
  const { classes } = props;
  return (
    <div className={classes.section}>



      <GridContainer>

        <GridItem xs={12} sm={12} md={12}>
          <Card
            raised
            background
            style={{ backgroundImage: "url(" + cardProject6 + ")" }}
          >
            <CardBody background>
              <h6 className={classes.category}>Efficiency, security, confidentiality, integrity, transparency</h6>
              <a href="http//torusred.com">
                <h3 className={classes.cardTitle}>
                  OPERATIONS GLOBAL NETWORK WITH TORUS
                </h3>
              </a>
              <p className={classes.category}>
                We greatly enjoy our working relationship with TORUS & PARTNERS NETWORK . They are always prepared and proactive, bringing new ideas to the table and executing at a high level. Strategies are well-conceived and always with our interests and objectives in mind.
              </p>
              <RegisterForm />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}

export default withStyles(sectionPillsStyle)(SectionPills);
